<template>
    <div class="breadcrumb-outer">
        <div
            class="breadcrumb-links"
            ref="breadcrumbLinks"
            style="display: flex;align-items: center;overflow: auto; z-index: 99; width: 100%; left: 0;font-size: 14px;">
            <ol style="width: max-content;max-width: unset!important;display: flex;justify-content: flex-start;list-style-type: none;padding-inline-start: 0;margin: 0;">
                <slot/>
            </ol>
        </div>
    </div>
</template>

<script>
    export default {
        mounted () {
            setTimeout(() => {
                const breadcrumbLinksElement = this.$refs.breadcrumbLinks;

                breadcrumbLinksElement.scrollLeft = breadcrumbLinksElement.scrollWidth;
            }, 200);
        },
    }
</script>
